import { decodeOptimizationResultId } from 'domain/mmm/optimization-results/constants';
import MmmOptimizationResultsApi from 'services/api/MmmOptimizationResultsApi';
import { saveAs } from 'services/utils';

const mapListItem = (item) => ({
  id: item.id,
  name: item.name,
  updatedAt: item.updated_at,
});

const sortListItems = (items) =>
  [...items].sort((a, b) => (a.updatedAt || '').localeCompare(b.updatedAt || ''));

export const listOptimizationResults = async () => {
  const response = await MmmOptimizationResultsApi.getList();
  return sortListItems((response.data.data ?? []).map(mapListItem));
};

export const getOptimizationResultDetail = async (resultId) => {
  const normalizedId = decodeOptimizationResultId(resultId);
  if (!normalizedId) {
    throw new Error('INVALID_RESULT_ID');
  }

  const response = await MmmOptimizationResultsApi.getDetail(normalizedId);
  return response.data.data;
};

export const exportOptimizationResult = async (resultId) => {
  const normalizedId = decodeOptimizationResultId(resultId);
  if (!normalizedId) {
    throw new Error('INVALID_RESULT_ID');
  }

  const { downloadUrl, fileName } =
    await MmmOptimizationResultsApi.getExportUrl(normalizedId);
  const response = await fetch(downloadUrl);
  if (!response.ok) {
    throw new Error('EXPORT_FAILED');
  }

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  try {
    await saveAs(objectUrl, fileName);
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
};

export const extractOptimizationResultIdFromPath = (pathname) => {
  const match = pathname.match(/^\/mmm\/optimization-results\/([^/]+)$/);
  if (!match || match[1] === 'list') {
    return null;
  }
  return decodeOptimizationResultId(match[1]);
};
